import React, { FunctionComponent } from "react";
import styles from "./Spots.module.scss";
import SpotsContent from "./SpotsContent.model";
import Spot from "./components/Spot/Spot";
import getWrapperStyles from "blocks/helpers/getWrapperStyles";
import combineClasses from "helpers/combine-classes";

const Spots: FunctionComponent<SpotsContent> = (props) => {
    const wrapperStyles = getWrapperStyles(props.settings);
    const bgColor = props.settings?.backgroundColor?.color || "#d8e8c5";

    return (
        <section
            className={combineClasses([styles.wrapper, ...wrapperStyles])}
            style={{ backgroundColor: bgColor }}
        >
            <div className={styles.container}>
                {/* Spots */}
                {props.content.spots && props.content.spots.length > 0 && props.settings ? (
                    <div className={combineClasses([styles.list, props?.content?.horizontalAlignment && styles.enableStagger])}>
                        {props.content.spots.map((item) => {
                            return (
                                <Spot
                                    // {...props.settings}
                                    key={item.contentUdi}
                                    {...item}
                                    enableCurves={props?.content?.enableCurves ?? false}
                                />
                            );
                        })}
                    </div>
                ) : null}
            </div>
        </section>
    );
};

export default Spots;
